import { render, staticRenderFns } from "./loadingBot.vue?vue&type=template&id=504601c6"
import script from "./loadingBot.vue?vue&type=script&lang=js"
export * from "./loadingBot.vue?vue&type=script&lang=js"
import style0 from "./loadingBot.vue?vue&type=style&index=0&id=504601c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports